module.exports = __webpack_public_path__ + "static/img/dollar_sign.2e56951f.png";